





















































import { defineComponent } from '@nuxtjs/composition-api';
import BaseSelectOption from '@shared/components/@atoms/BaseSelectOption/BaseSelectOption.vue';
import { focus, willChange } from '@shared/ui/utilities/directives';
import Vue from 'vue';

Vue.component('BaseSelectOption', BaseSelectOption);
export default defineComponent({
  name: 'BaseSelect',
  directives: { focus, willChange },
  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: 'This field is not correct.',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  methods: {
    // @ts-ignore migrated from ui-library
    changeHandler(event) {
      this.$emit('input', event.target.value);
    },
  },
});
